/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformSettingsResponseAdminDto } from '../../models/platform-settings-response-admin-dto';

export interface AdminPlatformSettingsControllerGetSettingsV1$Params {
}

export function adminPlatformSettingsControllerGetSettingsV1(http: HttpClient, rootUrl: string, params?: AdminPlatformSettingsControllerGetSettingsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformSettingsResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminPlatformSettingsControllerGetSettingsV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformSettingsResponseAdminDto>;
    })
  );
}

adminPlatformSettingsControllerGetSettingsV1.PATH = '/v1/admin/platform-settings';
